import React, { Component } from 'react'
import { Row, Col, Container } from "react-bootstrap";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import CardLessDataTable from '../../datatables/CardLessDataTableWithSearch';
import { withApollo } from "react-apollo";
import MaterialStudentDetailsModal from './MaterialStudentDetailsModal';
import MaterialstoreCreationModal from './materialstoreCreationModal';
import MaterialTabs from '../MaterialTabs';
import { MaterialPageShimmer, MaterialTableShimmer } from '../MaterialShimmer';
import { scopeBranches, filterAuthorizedBranches, onBranchScopeChange } from "../../../../utils/branchScope";


const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_MATERIAL_TYPES = gql`
  query($id:Int){
    getMaterialTypes(id:$id){
      id
      material_type
      is_grouping
    }
  }
`;

const GET_MATERIAL_STORE_REPORT = gql`
  query($institute_id:Int,$branch_id:Int,$material_type_id:Int,$class_id:String){
    getMaterialStoreReport(institute_id:$institute_id,branch_id:$branch_id,material_type_id:$material_type_id,class_id:$class_id){
      material_id
      material_name
      bec
      total_students
      total_quantity { material_count material_received_date }
      total_quantity_count
      required_quantity_count
      excess_quantity_count
      delivered_count
      not_delivered_count
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) { super(props); this.state = { open: false }; this.ref = React.createRef(); }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => { if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false }); };
    toggle = (id) => { const { value, onChange } = this.props; onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]); };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0 ? placeholder : value.length === options.length ? `All (${options.length})` : value.length === 1 ? (options.find((o) => o.value === value[0])?.label || `${value.length} selected`) : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })} style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 42 }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 240, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))} style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)} style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const FIN = {
    wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
    card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
    cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
    iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
    cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
    cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
    cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
    headerActions: { display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" },
    filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
    label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
    select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    content: { padding: "20px 24px" },
};

class MaterialStoreHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            // Every branch the user is authorized for — the creation modal writes a
            // branch_id, so it must not be narrowed by the header's filter scope.
            allBranches: [],
            getClasses: [],
            materialTypesData: [],
            materialTypeSearch: "0",
            materialTypeError: "",
            classSearch: [],
            classError: "",
            is_grouping: true,
            loader: 0,
            materialStoreData: [],
            noDateError: "",
            rowData: [],
            materialStudentDetailsModal: false,
            materialstoreCreationModal: false,
            initialLoad: true,
        };
    }

    async componentDidMount() {
        await this.loadFilters();
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.loadFilters());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    loadFilters = async () => {
        try {
            const [branchesRes, classesRes, typesRes] = await Promise.all([
                this.props.client.query({ query: GET_BRANCHES, variables: { institution_id: parseInt(Cookies.get("institutionid")) }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_CLASSES, variables: { id: 1 }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_MATERIAL_TYPES, variables: { id: 0 }, fetchPolicy: "network-only" }),
            ]);
            const all = branchesRes.data.getBranches || [];
            this.setState({
                // Report side: the header's branch selection IS this page's branch filter.
                branches: scopeBranches(all),
                // Data-entry side: MaterialstoreCreationModal still writes a branch_id, so
                // it keeps every branch the user is authorized for, not just the scope.
                allBranches: filterAuthorizedBranches(all),
                getClasses: classesRes.data.getExamClasses || [],
                materialTypesData: typesRes.data.getMaterialTypes || [],
                initialLoad: false,
                classSearch: [], materialStoreData: [], noDateError: "",
            });
        } catch (err) {
            console.error("material store load error", err);
            this.setState({ initialLoad: false });
        }
    }

    // Class options now span every branch the header has in scope, instead of the
    // one branch a local dropdown used to pick.
    classOptions = () => {
        const sections = this.state.branches.flatMap(b => b.sections || []);
        const classIds = [...new Set(sections.map(s => Number(s.class_id)))];
        return classIds.map(cid => this.state.getClasses.find(c => c.id === cid)).filter(Boolean).map(c => ({ value: c.id, label: c.class }));
    };

    onMaterialTypeChange = (e) => {
        const value = e.target.value;
        if (value === "0") {
            this.setState({ materialTypeSearch: "0", materialTypeError: "", is_grouping: true, classSearch: [], materialStoreData: [], noDateError: "" });
            return;
        }
        const grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1;
        this.setState({ materialTypeSearch: value, materialTypeError: "", is_grouping: grouping, classSearch: [], classError: "", materialStoreData: [], noDateError: "" });
    };

    onClassChange = (classIds) => {
        this.setState({ classSearch: classIds, classError: "", materialStoreData: [], noDateError: "" });
    };

    handleSubmit = async () => {
        if (this.state.materialTypeSearch === "0") { this.setState({ materialTypeError: "Please Select Material Type" }); return; }
        if (this.state.is_grouping && !this.state.classSearch.length) { this.setState({ classError: "Please Select Class" }); return; }

        // The service takes a single branch_id, so the header's branch scope is
        // fanned out and the rows concatenated.
        const branchIds = this.state.branches.map(b => parseInt(b.id)).filter(id => !isNaN(id));
        if (!branchIds.length) { this.setState({ materialStoreData: [], loader: 0, noDateError: "No Data Available" }); return; }

        this.setState({ loader: 1 });
        try {
            const results = await Promise.all(branchIds.map(branch_id => this.props.client.query({
                query: GET_MATERIAL_STORE_REPORT,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    material_type_id: parseInt(this.state.materialTypeSearch),
                    branch_id,
                    class_id: this.state.is_grouping ? this.state.classSearch.join(",") : null,
                },
                fetchPolicy: 'network-only'
            })));
            // Rows already carry their own "Branch / Class" (bec) label, so a plain
            // concat keeps every branch distinguishable in the table.
            const data = results.flatMap(r => r.data.getMaterialStoreReport || []);
            if (data.length > 0) {
                this.setState({ materialStoreData: data, loader: 0, noDateError: "" });
            } else {
                this.setState({ materialStoreData: [], loader: 0, noDateError: "No Data Available" });
            }
        } catch (err) {
            console.error("getMaterialStoreReport error", err);
            this.setState({ materialStoreData: [], loader: 0, noDateError: "No Data Available" });
        }
    };

    articlecolumns = [
        { dataField: "material_name", text: "Material", sort: true },
        { dataField: "bec", text: "Branch / Class", sort: true },
        { dataField: "total_Students", text: "Total Students", sort: true },
        { dataField: "total_quantity", text: "Total Quantity", sort: true, formatter: this.materialStudentData.bind(this) },
        { dataField: "req_quantity", text: "Req Quantity", sort: true },
        { dataField: "excess_quantity", text: "Excess Quantity", sort: true },
        { dataField: "delivered", text: "Delivered", sort: true },
        { dataField: "pending", text: "Not Delivered", sort: true },
    ];

    materialStudentData(val, row) {
        return (
            <div>
                <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ materialStudentDetailsModal: true, rowData: row }) }}>{val}</a>
            </div>
        )
    }

    tableData(data) {
        return data.map((mapData) => ({
            material_name: mapData.material_name,
            bec: mapData.bec,
            total_Students: mapData.total_students,
            total_quantity: mapData.total_quantity_count,
            req_quantity: mapData.required_quantity_count,
            excess_quantity: mapData.excess_quantity_count,
            delivered: mapData.delivered_count,
            pending: mapData.not_delivered_count,
            totalQuantityData: mapData.total_quantity
        }));
    }

    render() {
        if (this.state.initialLoad) {
            return <MaterialPageShimmer filters={3} />;
        }

        const { classSearch } = this.state;
        const classOptions = this.classOptions();

        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>
                        <MaterialTabs active="store" />
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-warehouse" /></div>
                            <div style={FIN.cardTitleText}>
                                <h5 style={FIN.cardTitle}>Material Store Report</h5>
                                <span style={FIN.cardSubtitle}>Stock, delivery &amp; quantity overview</span>
                            </div>
                            <div style={FIN.headerActions}>
                                <button style={FIN.btnPrimary} onClick={() => { this.setState({ materialstoreCreationModal: true }) }}>
                                    <i className="fas fa-plus" /> Material Update
                                </button>
                            </div>
                        </div>

                        <div style={FIN.filterBar}>
                            <Row className="g-2 align-items-end">
                                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Material Type</label>
                                    <select style={FIN.select} value={this.state.materialTypeSearch} onChange={this.onMaterialTypeChange}>
                                        <option value="0" disabled>Select Material Type</option>
                                        {this.state.materialTypesData.map(t => <option key={t.id} value={t.id}>{t.material_type}</option>)}
                                    </select>
                                    {this.state.materialTypeError ? <span style={FIN.err}>{this.state.materialTypeError}</span> : null}
                                </Col>
                                {/* No Branch filter — the header's branch selection scopes this report. */}
                                {this.state.is_grouping ? (
                                    <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                                        <label style={FIN.label}>Class</label>
                                        <CheckboxDropdown options={classOptions} value={classSearch} onChange={this.onClassChange} placeholder="Select Class(es)" />
                                        {this.state.classError ? <span style={FIN.err}>{this.state.classError}</span> : null}
                                    </Col>
                                ) : null}
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <button style={{ ...FIN.btnPrimary, width: "100%" }} onClick={this.handleSubmit}>
                                        <i className="fas fa-search" /> Submit
                                    </button>
                                </Col>
                            </Row>
                        </div>

                        <div style={FIN.content}>
                            {this.state.loader == 1 ? (
                                <MaterialTableShimmer rows={6} cols={8} />
                            ) : this.state.materialStoreData.length > 0 ? (
                                <CardLessDataTable parentData={this.tableData(this.state.materialStoreData)} particlecolumns={this.articlecolumns} name="attendance" />
                            ) : this.state.noDateError != "" ? (
                                <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                                    <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-warehouse" /></div>
                                    <h6 style={{ color: "#64748b" }}>{this.state.noDateError}</h6>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>

                <MaterialStudentDetailsModal
                    stateData={this.state}
                    show={this.state.materialStudentDetailsModal}
                    onHide={() => this.setState({ materialStudentDetailsModal: false })}
                />
                <MaterialstoreCreationModal
                    branches={this.state.allBranches}
                    getClasses={this.state.getClasses}
                    stateData={this.state}
                    show={this.state.materialstoreCreationModal}
                    onHide={() => this.setState({ materialstoreCreationModal: false })}
                    getMaterialTypes={this.state.materialTypesData}
                />
            </div>
        )
    }
}

export default withRouter(withApollo(MaterialStoreHome));
